// extracted by css-extract-rspack-plugin
export default {"cls1":"SourceForm-cls1_DAK","cls2":"SourceForm-cls2_5UU SourceForm-cls1_DAK"};